import axios from "axios";

export const getArticle = id => {
  return axios.get(`/api/intranet/v1/articles/show_by_token/${id}`);
};
